import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=4d240e46&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d240e46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d240e46')) {
      api.createRecord('4d240e46', component.options)
    } else {
      api.reload('4d240e46', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=4d240e46&scoped=true&", function () {
      api.rerender('4d240e46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Category/Form.vue"
export default component.exports